export const SDK_TIMEOUT_LADDER_MS = [10_000, 20_000, 30_000];
